import { RCCSortableDragOverlay } from "react-common-components";

export default RCCSortableDragOverlay;
